/* eslint-disable */
export enum PurposeOfVisitEnum {
  BUSINESS = 'business',
  IMMIGRATION = 'immigration',
  STUDIES = 'studies',
  TOURIST = 'tourist',
  WORK = 'work'
}

